var _circle, _path, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.26,
    cy: 20.038,
    r: 4.048
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.564 29.64v-.727a3.844 3.844 0 00-3.845-3.845h-6.918a3.844 3.844 0 00-3.845 3.845v.727"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 18.657,
    cy: 29.09,
    r: 1.445
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M27.434 7.075h1.761c2.74 0 4.961 2.099 4.961 4.689v22.997c0 2.59-2.221 4.689-4.961 4.689h-15.87c-2.74 0-4.961-2.099-4.961-4.689V11.764c0-2.59 2.221-4.689 4.961-4.689h1.776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.788 3.201h2.944v5.027a1.473 1.473 0 01-2.944 0V3.201z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnz);
export default __webpack_public_path__ + "static/media/ONZ.f28c60af4bf467b680adf076c3df929d.svg";
export { ForwardRef as ReactComponent };